<div id="build-your-community-part-one-overlay" class="left-overlay bgc-glass" [ngStyle]="overlayStyles">
  <p class="larger-font">
    Collaborate with your
    <b class="brand-primary-azure"
      ><a class="brand-navy-link" href="https://community.genesys.com" target="_blank" title="Community Link">
        Genesys Community</a
      ></b
    >, while expanding your expertise.
  </p>
  <app-community-list [role]="role" (linkClick)="onLinkClick()"></app-community-list>
</div>
